import {
  START_LOADING,
  FINISH_LOADING,
  CURRENT_ENTER,
  HEADER_STATUS,
  ROLE_ID,
  ROLE_Code
} from './mutation-type'

const mutations = {
  // 切换左侧导航的显示状态
  [START_LOADING] (state) {
    state.loading = true
  },
  [FINISH_LOADING] (state) {
    state.loading = false
  },
  [CURRENT_ENTER] (state,val) {
    state.currentPage = val
  },
  [HEADER_STATUS] (state,val) {
    state.headerStatus = val
  },
  [ROLE_ID] (state,val) {
    state.roleId = val
  },
  [ROLE_Code] (state,val) {
    state.roleCode = val
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/app/mutations.js